import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutateChildDTO } from "../../dto";

let body: MutateChildDTO;

export async function modifyChildAction(parent: any) {
  const token = localStorage.getItem("token");

  return await axios
    .patch(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/children/modify`,
      parent,
      {
        headers: {
          "content-type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutateChildDTO, res.data);
      await validate(body);
      /*const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }*/

      return res.data;
    });
}
